import { render, staticRenderFns } from "./NormalQuestionWrap.vue?vue&type=template&id=fef1ae04&scoped=true"
import script from "./NormalQuestionWrap.vue?vue&type=script&lang=js"
export * from "./NormalQuestionWrap.vue?vue&type=script&lang=js"
import style0 from "./NormalQuestionWrap.vue?vue&type=style&index=0&id=fef1ae04&prod&lang=less"
import style1 from "./NormalQuestionWrap.vue?vue&type=style&index=1&id=fef1ae04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef1ae04",
  null
  
)

export default component.exports